import React, { useEffect, useState } from 'react';
import { FileText } from 'lucide-react';
import API from '../utils/api';

// Aadhar / horoscope documents are private files: the server only returns them to a request
// carrying the admin token, so they are loaded as blobs rather than via a plain <img>/<a> URL.
const PrivateDoc = ({ url, alt = '', pdfClassName, pdfLabel = 'PDF' }) => {
    const filename = String(url || '').split('/').pop();
    const isPdf = filename.toLowerCase().endsWith('.pdf');
    const [blobUrl, setBlobUrl] = useState('');
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        let objectUrl = '';
        let cancelled = false;
        API.get(`/files/doc/${encodeURIComponent(filename)}`, { responseType: 'blob' })
            .then(res => {
                if (cancelled) return;
                objectUrl = URL.createObjectURL(res.data);
                setBlobUrl(objectUrl);
            })
            .catch(() => { if (!cancelled) setFailed(true); });
        return () => { cancelled = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
    }, [filename]);

    if (isPdf || failed || !blobUrl) {
        const body = <span className={pdfClassName}><FileText size={20} /><b>{failed ? 'Unavailable' : isPdf ? pdfLabel : 'Loading…'}</b></span>;
        return blobUrl ? <a href={blobUrl} target="_blank" rel="noopener noreferrer">{body}</a> : body;
    }
    return <a href={blobUrl} target="_blank" rel="noopener noreferrer"><img src={blobUrl} alt={alt} /></a>;
};

export default PrivateDoc;
